import React from "react";
import { Box, Tabs, Tab, SxProps, Theme } from "@mui/material";

export interface SecondaryTabsNavProps {
  tabs: string[];
  value: number;
  onChange: (event: React.SyntheticEvent, newValue: number) => void;
  sx?: SxProps<Theme>;
  [key: string]: any; // for other Box props if needed
}

const SecondaryTabsNav: React.FC<SecondaryTabsNavProps> = ({
  tabs,
  value,
  onChange,
  sx = {},
  ...props
}) => (
  <Box
    sx={{
      borderRadius: "8px",
      p: "24px 32px 12PX 32PX",
      boxSizing: "border-box",
      width: "100%",
      display: "flex",
      justifyContent: "flex-start",
      ...sx,
    }}
    {...props}
  >
    <Tabs
      value={value}
      onChange={onChange}
      variant="scrollable"
      scrollButtons="auto"
      TabIndicatorProps={{ style: { display: "none" } }}
      sx={{
        background: 'var(--background-off-white)',
        p: "4px",
        borderRadius: "8px",
        minHeight: 0,
        "& .MuiTab-root": {
          minHeight: 0,
          minWidth: 0,
          textTransform: "none",
          fontWeight: 500,
          color: "#333",
          px: 2,
          py: .75,
          mr: '6px',
          borderRadius: "10px",
          background: "transparent",
          transition: "background 0.2s",
          '&:last-child': {
            mr: 0,
          }
        },
        "& .Mui-selected": {
          fontWeight: 700,
          color: '#111111 !important',
          fontSize: 14,
          background: "#fff",
          borderRadius: '6px',
        },
      }}
    >
      {tabs.map((label, idx) => (
        <Tab key={label} label={label} disableRipple />
      ))}
    </Tabs>
  </Box>
);

export default SecondaryTabsNav;
